export default __webpack_public_path__ + "static/media/product.586b516a.png";